import React, { useState } from "react";
import { createRoot } from "react-dom/client";
import { useApp } from "@modelcontextprotocol/ext-apps/react";

function App() {
  const [message, setMessage] = useState(null);
  const [safeAreaInsets, setSafeAreaInsets] = useState({
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
  });

  useApp({
    appInfo: { name: "Hello World", version: "1.0.0" },
    capabilities: {},
    onAppCreated: (app) => {
      app.ontoolresult = (result) => {
        setMessage(result.structuredContent?.message ?? null);
      };

      app.onhostcontextchanged = () => {
        const ctx = app.getHostContext();
        if (ctx?.safeAreaInsets) {
          setSafeAreaInsets(ctx.safeAreaInsets);
        }
      };

      const ctx = app.getHostContext();
      if (ctx?.safeAreaInsets) {
        setSafeAreaInsets(ctx.safeAreaInsets);
      }
    },
  });

  React.useEffect(() => {
    const styleId = "hello-world-bg-style";
    let style = document.getElementById(styleId);
    if (!style) {
      style = document.createElement("style");
      style.id = styleId;
      style.textContent = `
        html, body {
          background-color: #212121 !important;
          margin: 0 !important;
          padding: 0 !important;
          width: 100%;
          height: 100%;
        }
      `;
      document.head.appendChild(style);
    }
    return () => {
      const s = document.getElementById(styleId);
      if (s) s.remove();
    };
  }, []);

  return (
    <div
      className="antialiased fixed inset-0 w-full h-full flex flex-col items-center justify-center text-white"
      style={{
        backgroundColor: "#212121",
        paddingTop: safeAreaInsets.top,
        paddingRight: safeAreaInsets.right,
        paddingBottom: safeAreaInsets.bottom,
        paddingLeft: safeAreaInsets.left,
      }}
    >
      <div className="flex flex-col items-center gap-4 px-6 text-center">
        <div className="text-xs font-semibold tracking-widest uppercase text-white/40">
          Headout
        </div>
        <h1 className="text-4xl font-bold tracking-tight">Welcome to BLR</h1>
        <div className="w-12 h-0.5 rounded-full bg-[#8000FF]" />
        {message ? (
          <p className="text-lg text-white/70 max-w-sm">{message}</p>
        ) : (
          <div className="h-6 w-48 rounded bg-white/10 animate-pulse" />
        )}
      </div>
    </div>
  );
}

const rootElement = document.createElement("div");
rootElement.id = "hello_world-root";
document.body.replaceChildren(rootElement);
createRoot(rootElement).render(<App />);
